import { useState } from 'react';
import { db, auth } from '../firebase';
import { collection, setDoc, doc } from 'firebase/firestore';
import './TrainingAdmin.css';

function OverallCourseRating() {
    const [courserating, setCourseRating] = useState(5);
    const [comment, setComment] = useState('');
    const [submitMessage, setSubmitMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const user = auth.currentUser;
            if (!user) {
                setSubmitMessage('You must be logged in to submit a review');
                return;
            }

            const userReviewRef = doc(db, 'user-reviews', user.uid);
            
            await setDoc(userReviewRef, {
                courserating: Number(courserating),
                comment,
                userId: user.uid,
                userEmail: user.email,
                timestamp: new Date()
            }, { merge: true });

            setComment('');
            setCourseRating(5);
            setSubmitMessage('Review submitted successfully!');
        } catch (error) {
            setSubmitMessage('Error submitting review: ' + error.message);
        }
    };

    return (
        <div className="App" style={{ height: '100vh', overflow: 'hidden' }}>
            <header className="App-header" style={{ height: '100%', overflow: 'hidden' }}>
                <h1 style={{ fontSize: '1.8rem' }}>Course Ratings & Reviews</h1>
                
                <div style={{ 
                    display: 'flex', 
                    height: 'calc(100% - 100px)', 
                    overflow: 'hidden',
                    padding: '20px',
                    maxWidth: '1200px',
                    margin: '0 auto'
                }}>
                    <div style={{ 
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div className="form-section" style={{
                            background: '#2a2a2a',
                            padding: '40px',
                            borderRadius: '8px',
                            border: '1px solid rgba(255,255,255,0.1)'
                        }}>
                            <h2 style={{ 
                                fontSize: '1.2rem', 
                                color: '#87CEEB',
                                marginBottom: '20px'
                            }}>Submit Your Review</h2>
                            <form onSubmit={handleSubmit} style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '15px'
                            }}>
                                <div className="form-group">
                                    <label style={{ marginBottom: '8px', display: 'block' }}>Course Rating:</label>
                                    <div style={{ 
                                        display: 'flex', 
                                        gap: '4px'
                                    }}>
                                        {[1, 2, 3, 4, 5].map((star) => (
                                            <button
                                                key={star}
                                                type="button"
                                                onClick={() => setCourseRating(star)}
                                                style={{
                                                    background: 'transparent',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    padding: '2px',
                                                    color: star <= courserating ? '#ffd700' : '#666'
                                                }}
                                            >
                                                <svg
                                                    width="32"
                                                    height="32"
                                                    viewBox="0 0 24 24"
                                                    fill={star <= courserating ? 'currentColor' : 'none'}
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                >
                                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                                </svg>
                                            </button>
                                        ))}
                                        <span style={{ 
                                            marginLeft: '8px', 
                                            color: '#87CEEB',
                                            alignSelf: 'center' 
                                        }}>
                                            {courserating}/5
                                        </span>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ marginBottom: '8px', display: 'block' }}>Your Comments:</label>
                                    <textarea
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                        required
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            background: '#1a1a1a',
                                            border: '1px solid #444',
                                            borderRadius: '4px',
                                            color: 'white',
                                            minHeight: '100px',
                                            resize: 'vertical'
                                        }}
                                        rows="4"
                                    />
                                </div>
                                <button type="submit" style={{
                                    padding: '12px',
                                    background: 'linear-gradient(to right, #4B89DC, #3498db)',
                                    border: 'none',
                                    borderRadius: '6px',
                                    color: 'white',
                                    cursor: 'pointer',
                                    fontSize: '1rem',
                                    fontWeight: '500',
                                    transition: 'transform 0.2s'
                                }}>Submit Review</button>
                            </form>
                            {submitMessage && (
                                <div style={{
                                    marginTop: '15px',
                                    padding: '10px',
                                    borderRadius: '4px',
                                    background: submitMessage.includes('Error') ? '#ff44336e' : '#4caf506e',
                                    color: 'white'
                                }}>
                                    {submitMessage}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </header>
        </div>
    );
}

export default OverallCourseRating; 